"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGigyaLogout = exports.useGigyaAccount = exports.useGigyaService = void 0;
const useGigyaService = (gigyaContext) => {
    const { gigya, isLoaded } = gigyaContext;
    // Method to render the Gigya prebuilt login component
    const renderGigyaComponent = (props) => {
        if (!gigya)
            throw new Error('Gigya is not loaded');
        gigya.accounts.showScreenSet(Object.assign(Object.assign({ containerID: props.componentId, screenSet: props.screenset }, (props.extras ? props.extras : {})), { lang: props.context.locale, startScreen: props.page, context: props.context }));
    };
    return { renderGigyaComponent, isLoaded };
};
exports.useGigyaService = useGigyaService;
const useGigyaAccount = (gigyaContext) => {
    const { gigya, isLoaded } = gigyaContext;
    // Load SSO
    const loadSSO = (props) => {
        try {
            if (!gigya)
                throw new Error('Gigya is not loaded');
            gigya.sso.login({
                authFlow: props.authFlow,
                context: props.context,
            });
        }
        catch (error) {
            console.error('Error loading SSO:', error);
        }
    };
    // Check User Session and return Null Or user Response 
    const isAuthorized = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!gigya)
                throw new Error('Gigya is not loaded');
            const getAccount = yield new Promise((resolve, reject) => {
                let info = null;
                gigya.accounts.session.verify({
                    callback: function (response) {
                        return __awaiter(this, void 0, void 0, function* () {
                            if (response.status === "OK") {
                                const info = yield getAccountInfo(gigya);
                                resolve(info);
                            }
                            else {
                                resolve(null);
                            }
                        });
                    },
                });
            });
            return getAccount;
        }
        catch (error) {
            console.error('Error in authorization check:', error);
            return null;
        }
    });
    return { isLoaded, loadSSO, isAuthorized };
};
exports.useGigyaAccount = useGigyaAccount;
const getAccountInfo = (gigya) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        return new Promise((resolve, reject) => {
            gigya.accounts.getAccountInfo({
                callback: (response) => {
                    if (response.status === "OK") {
                        resolve(response);
                    }
                    else {
                        resolve(null);
                    }
                }
            });
        });
    }
    catch (error) {
        console.error('Error retrieving account info:', error);
    }
});
const useGigyaLogout = (gigyaContext) => {
    const { gigya, isLoaded } = gigyaContext;
    const GigyaLogout = (onLogoutCallback) => {
        try {
            if (!gigya)
                throw new Error('Gigya is not loaded');
            // Perform logout
            gigya.accounts.logout({
                callback: onLogoutCallback,
            });
        }
        catch (error) {
            console.error('Error occurred during Gigya logout:', error);
        }
    };
    return { isLoaded, GigyaLogout };
};
exports.useGigyaLogout = useGigyaLogout;
